import {t} from 'i18next';
import React from 'react';
import {Link} from 'react-router-dom';
import {IconNames} from '../../../common/aur-icon/AurIcon';
import AurTabWithIcons, {
  ITabIconLabel,
} from '../../../common/aur-tab-with-icons/AurTabWithIcons';

const TabWithIcons: React.FC = () => {
  const tabIconLabelArray: ITabIconLabel[] = [
    {
      label: t('indexSearchPage.aurTabControl.fields'),
      icon: IconNames.PostAddOutlined,
      tabIndex: 0
    },
    {
      label: (
        <span>
          {t('indexSearchPage.aurTabControl.saved')}
          <br />
          {t('indexSearchPage.aurTabControl.searches')}
        </span>
      ),
      icon: IconNames.BookmarksOutlined,
      tabIndex: 1
    },
    {
      label: t('indexSearchPage.aurTabControl.tags'),
      icon: IconNames.Tag,
      tabIndex: 2,
    },
    {
      label: t('indexSearchPage.aurTabControl.exports'),
      icon: IconNames.Export,
      tabIndex: 4,
    },
  ];

  return (
    <>
      <div style={{marginBottom: '64px'}}>
        <h1>Tab with Icons Component</h1>
        <div></div>
        <Link to="/demo">Return</Link>
        <hr />
        <div
          style={{
            marginBottom: '32px',
            width: '80%',
          }}
        >
          <AurTabWithIcons iconLabelArray={tabIconLabelArray} />
        </div>
      </div>
    </>
  );
};

export default TabWithIcons;
